import { render, staticRenderFns } from "./sjblLeft.vue?vue&type=template&id=665b2f60&scoped=true&"
import script from "./sjblLeft.vue?vue&type=script&lang=js&"
export * from "./sjblLeft.vue?vue&type=script&lang=js&"
import style0 from "./sjblLeft.vue?vue&type=style&index=0&id=665b2f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b2f60",
  null
  
)

export default component.exports